import React from 'react';
import { FilterType } from '../../types/hospital.types';
import './HospitalStats.css';

interface HospitalStatsProps {
  totalCount: number;
  activeCount: number;
  esicCount: number;
  emergencyCount: number;
  searchResultsCount: number;
  currentFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
}

const HospitalStats: React.FC<HospitalStatsProps> = ({
  totalCount,
  activeCount,
  esicCount,
  emergencyCount,
  searchResultsCount,
  currentFilter,
  onFilterChange
}) => {
  return (
    <div className="dashboard">
      <div className="stat-card total" onClick={() => onFilterChange('all')}>
        <span className="stat-number">{totalCount}</span>
        <span className="stat-label">Total Hospitals</span>
      </div>
      <div className={`stat-card active-hospitals ${currentFilter === 'all' ? 'active' : ''}`} onClick={() => onFilterChange('all')}>
        <span className="stat-number">{activeCount}</span>
        <span className="stat-label">Active</span>
      </div>
      <div className={`stat-card approved ${currentFilter === 'esic' ? 'active' : ''}`} onClick={() => onFilterChange('esic')}>
        <span className="stat-number">{esicCount}</span>
        <span className="stat-label">ESIC</span>
      </div>
      <div className={`stat-card pending ${currentFilter === 'emergency' ? 'active' : ''}`} onClick={() => onFilterChange('emergency')}>
        <span className="stat-number">{emergencyCount}</span>
        <span className="stat-label">Emergency</span>
      </div>
      <div className="stat-card">
        <span className="stat-number">{searchResultsCount}</span>
        <span className="stat-label">Search Results</span>
      </div>
    </div>
  );
};

export default HospitalStats;